import { useMutation } from '@tanstack/react-query';
import { CONFIG } from '@/lib/config/config';
import { processApiResponseReactQuery } from '@/lib/api/process-api-response-react-query.helper';
import { requestApi } from '@/lib/api/request-api.helper';

import { pushAnalyticsEvent } from '@/lib/helpers/analytics/analytics.helper';
import { MixpanelWrapper } from '@/lib/mixpanel/useMixpanel';
import { MIXPANEL_EVENTS } from '@/lib/mixpanel/mixpanel-events.constants';
import { useSignUpStore } from '../../useSignUp.store';

interface MutationProps {
  email: string;
  username: string;
  password: string;
  language: 'de' | 'en';
  utm_source?: string | null;
  click_ids?: string | null;
  sign_up_variant?: string | null;
}

export const useSignUpMutation = () => {
  const url = `${CONFIG.API.ENDPOINT}${CONFIG.API.METHODS.USER}`;

  const setSuccesCreateAccount = useSignUpStore((state) => state.setSuccesCreateAccount);
  const setClientID = useSignUpStore((state) => state.setClientID);
  return useMutation({
    mutationFn: async ({
      email,
      username,
      password,
      language,
      utm_source = null,
      click_ids = null,
      sign_up_variant = null
    }: MutationProps) => {
      const response = await requestApi.post({
        url,
        body: {
          email,
          username,
          password,
          language,
          utm_source,
          click_ids,
          sign_up_variant
        }
      });
      if (response?.status === 201) {
        const newResponse = response.clone();
        // we cannot call the response.json() twice, then we are using the response.clone() that exists for this purpose to make that possible
        const newResponseJson = await newResponse.json();
        setSuccesCreateAccount();
        setClientID(newResponseJson?.data);
        pushAnalyticsEvent({
          event: 'sign_up',
          user_type: 'customer',
          user_data: {
            user_id: newResponseJson?.data,
            email_address: email,
            address: {
              username: username
            }
          }
        });
        MixpanelWrapper.track(MIXPANEL_EVENTS.USER_SIGNUP, {
          'User ID': newResponseJson?.data,
          'Email Address': email,
          Username: username
        });
        console.log(newResponseJson);
      }

      return await processApiResponseReactQuery({ response });
    }
  });
};
